export const GET_POST_SUCCESS = "GET_POST_SUCCESS";
export const GET_POST_ERROR = "GET_POST_ERROR";
export const SEND_POST = "SEND_POST";
export const POST_DELETED = "POST_DELETED";
export const COMMENT_CREATED_ERROR = "COMMENT_CREATED_ERROR";
export const COMMENT_DELETED = "COMMENT_DELETED";
